export enum TenantConfigurations {
  IUPATWORKSITESLABEL = 'Employer Locations',
}
